/* global NDEFReader */

import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ModalRegistro.css';

const ModalSilla = ({ onClose, onSillaAsignada }) => {
  const [mensaje, setMensaje] = useState('Esperando lectura NFC...');
  const [sillaID, setSillaID] = useState(null);

  useEffect(() => {
    if ('NDEFReader' in window) {
      const reader = new NDEFReader();

      const startNFC = async () => {
        try {
          await reader.scan();
          //toast.info('Acerque su tag NFC...', { autoClose: 1000 });
          

          reader.onreading = (event) => {
            
            if (event.message.records && event.message.records.length > 0) {
              const record = event.message.records[0];
              let nfcData = '';

              if (record.data) {
                nfcData = new TextDecoder().decode(record.data);
              } else {
                nfcData = 'Datos no disponibles';
              }
              //toast.success('Silla registrada exitosamente', { autoClose: 1000 });
              setSillaID(nfcData);

              // Asignar el valor leído
              onSillaAsignada(nfcData);

              // Cerrar automáticamente después de unos segundos
              setTimeout(() => {
                onClose();
              }, 500);
            } else {
              
            }
          };
        } catch (error) {
          toast.error('Error al activar lector NFC', { autoClose: 1000 });
              setTimeout(() => {
                onClose();
              }, 500);
        }
      };

      startNFC();
    } else {
      toast.error('NFC no es compatible con este dispositivo', { autoClose: 1000 });
              setTimeout(() => {
                onClose();
              }, 500);
    }
  }, [onClose, onSillaAsignada]);

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal">
        <h2>Escanear NFC Silla</h2>
        <p>{mensaje}</p>

        {sillaID && (
          <div className="silla-detalles">
            <p><strong>ID de la silla:</strong> {sillaID}</p>
          </div>
        )}

        <div className="modal-actions">
          <button className="close" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </>
  );
};

export default ModalSilla;
